import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const LiveMapMobileMapStatsPanelStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-mobile-map-stats-panel",
  },
)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
`;
